module.exports = __webpack_public_path__ + "static/media/luna.0050a798.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/albums/luna.jpeg
// module id = 286
// module chunks = 0